module.exports = __webpack_public_path__ + "img/37a2fae04f959c3db0021e8bf1ae23e.22fc1a04.png";